import SnackbarContent from "@material-ui/core/SnackbarContent";
import InfoIcon from "@material-ui/icons/Info";
import Grid from "@material-ui/core/Grid";
import {animated, useTransition} from "react-spring";
import TicketCard from "../../component/TicketCard";
import React from "react";
import {connect} from "react-redux";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";


const Main = ({
    ticketList,
    downloadTicket,
    prepareStripeNameChange,
    requestRefund,
    updateTicket,
    toggleLoadingModal,
    getTicketData,
    isLoggedIn,
}) => {
    const transitions = useTransition(ticketList, item => item.hash, {
        from: {opacity: 0, transform: 'perspective(600px) rotateY(180deg)', height: '100%'},
        enter: {opacity: 1, transform: 'perspective(600px) rotateY(0deg)', height: '100%'},
        leave: {opacity: 0, height: '100%'},
        config: {mass: 5, tension: 500, friction: 80}
    })

    React.useEffect(() => {
        (async () => {
            toggleLoadingModal(true);
            await getTicketData();
            toggleLoadingModal(false);
        })();
    }, [isLoggedIn]);

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey="6LcHlRwjAAAAADjFS4CqfftFOBlVuiHhS73IfqAR"
        >
            <SnackbarContent
                style={{
                    backgroundColor: '#42474c',
                    marginBottom: 20
                }}
                message={
                    <span id="client-snackbar" style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <InfoIcon style={{fontSize: 20, marginRight: 10}}/>
                        If your ticket isn't listed below and you have purchased via a ticket seller or received your ticket
                        directly from crew then please contact the person who issued you the ticket to make the name change.
                        <br/>
                        <br/>
                        Experiencing issues? please contact us at support@triniq.com
                    </span>
                }
            />
            <Grid container spacing={3}>
                {transitions.map(({item, key, props: transitionProps}) =>
                    <Grid item md={4} sm={6} xs={12} key={'ticket_' + item.hash}>
                        <animated.div style={transitionProps} key={key}>
                            <TicketCard
                                onDownload={downloadTicket}
                                onConfirmClick={prepareStripeNameChange}
                                onRequestRefund={requestRefund}
                                onConfirmTransferPaid={updateTicket}
                                onConfirmTransferToggle={updateTicket}
                                toggleLoadingModal={toggleLoadingModal}
                                {...item}
                            />
                        </animated.div>
                    </Grid>
                )}
            </Grid>
        </GoogleReCaptchaProvider>
    )
}

const mapState = state => {
    return {
        ticketList: state.ticket.ticketList,
        isLoggedIn: state.auth.isLoggedIn,
    }
}

const mapDispatch = dispatch => ({
    downloadTicket: dispatch.ticket.downloadTicket,
    getTicketData: dispatch.ticket.getTicketData,
    prepareStripeNameChange: dispatch.ticket.prepareStripeNameChange,
    requestRefund: dispatch.ticket.requestRefund,
    updateTicket: dispatch.ticket.updateTicket,
    toggleLoadingModal: dispatch.ticket.toggleLoadingModal,
})

export default connect(mapState, mapDispatch)(Main);
